<mat-card class="filter">
  <div class="sortview">
    <div class="sortby" *ngIf="AllCustomInfoListShow">
      <mat-form-field>
        <mat-label>Filter by</mat-label>
        <mat-select matInput (selectionChange)="onChangeSelectedType($event)">
          <mat-option *ngFor="let rel of CustomInfoTypeForFilter" [value]="rel.customInfoTypeID">
            {{rel.customInfoName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </div>

 

  <div class="selectact">      
    <button mat-flat-button color="primary" (click)="addCustomInfo()">
      <mat-icon>add</mat-icon> Add Custom Info
    </button>
  </div>
</mat-card>



<div class="touches_holder">

  <mat-card class="touches" *ngFor="let touch of AllCustomInfoList; let i = index ">
      <app-customInfo-list [touch]="touch"  
      (editCustomInfoEmmitter)="editCustomInfo($event)"
      (deleteCustomInfoEmmitter)="deleteCustomInfo($event)">
    </app-customInfo-list>
      
  </mat-card>
 
  <mat-card class="touches" *ngIf="AllCustomInfoList==null && AllCustomInfoListShow">
    <p> No Record Found</p>
  </mat-card>



</div>


